
import CaregiverCalendar from './CaregiverCalendar';
import CaregiverDetail from './CaregiverDetail';
import CaregiverList from './CaregiverList';
import CaregiverNew from './CaregiverNew';
import LoomStatus from './LoomStatus';
import Status from './Status';
import CaregiverBiography from './CaregiverBiography';
import CaregiverReview from './CaregiverReview';


export default {
  CaregiverCalendar,
  CaregiverDetail,
  CaregiverList,
  CaregiverNew,
  LoomStatus,
  Status,
  CaregiverBiography,
  CaregiverReview,
};
